import React from 'react'
import {
  EuiModal,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiModalBody,
  EuiModalFooter,
  EuiButtonEmpty,
  EuiButton,
  EuiForm,
  EuiFormRow,
  EuiFieldText,
  EuiCodeBlock,
  EuiAccordion,
  EuiFlexGroup,
  EuiFlexItem
} from '@elastic/eui'
import KpiService from '../services/kpi.service'

/**
 * Composant Modal pour l'administration des KPIs
 */
const KpiModal = ({ 
  isVisible, 
  onClose, 
  kpiDocument, 
  onFieldChange, 
  onSubmit 
}) => {
  const handleSubmit = (evt) => {
    evt.preventDefault()
  }

  const formModal = () => {
    if (kpiDocument) {
      return (
        <EuiForm id="modalForm" component="form" onSubmit={handleSubmit}>
          {KpiService.kpisGroup
            .filter((key, value) => {
              return ['perimetre_supervise', 'log'].indexOf(key) > -1
            })
            .map((key, value) => {
              return (
                <EuiAccordion
                  key={key}
                  id={'accordion_' + key}
                  buttonContent={
                    KpiService.kpisLabel[KpiService.kpisGroup.indexOf(key)]
                  }
                >
                  <EuiFlexGroup>
                    <EuiFlexItem>
                      <EuiFormRow label="Nom du rapport :">
                        <EuiFieldText
                          id={key + '.green.report'}
                          name={key + '.report'}
                          defaultValue={
                            kpiDocument[key]?.report
                              ? kpiDocument[key].report
                              : ''
                          }
                          onChange={(e) => onFieldChange(e, 'string', key)}
                        />
                      </EuiFormRow>
                    </EuiFlexItem>
                  </EuiFlexGroup>
                </EuiAccordion>
              )
            })}
        </EuiForm>
      )
    }
  }

  if (!isVisible) return null

  return (
    <EuiModal id="modalAdminKpis" onClose={onClose}>
      <EuiModalHeader>
        <EuiModalHeaderTitle>
          <h1>Administration KPIS</h1>
        </EuiModalHeaderTitle>
      </EuiModalHeader>

      <EuiModalBody>
        {formModal()}
        <EuiCodeBlock
          language="json"
          overflowHeight={300}
          isCopyable
          isVirtualized
        >
          {JSON.stringify(kpiDocument, null, 2)}
        </EuiCodeBlock>
      </EuiModalBody>

      <EuiModalFooter>
        <EuiButtonEmpty onClick={onClose}>Annuler</EuiButtonEmpty>
        <EuiButton type="submit" onClick={onSubmit} fill>
          Sauvegarder
        </EuiButton>
      </EuiModalFooter>
    </EuiModal>
  )
}

export default KpiModal
